import { css } from 'styled-components';
import {
  getSpacing, getTypography, TypographyName, SpacingName, ThemedFunctor, grid, gridUnit,
} from '@doveit/lego';

export const imageMobileSize = '4rem';
export const imageDesktopSize = '4.5rem';

export const base: ThemedFunctor = ({ theme }) => css`
  ${getSpacing.padding(theme, SpacingName.MEDIUM)}
  border: 2px solid ${theme.palettes.neutrals.light};
  border-radius: 6px;
`;

export const content: ThemedFunctor = ({ theme }) => css`
  ${grid(theme)}
  ${getSpacing.margin(theme, [SpacingName.NEGATIVE_SMALLER, SpacingName.NEGATIVE_MEDIUM])}
`;

export const box: ThemedFunctor = ({ theme }) => css`
  ${gridUnit(theme, { size: { MD: 1 / 2 } })}
  ${getSpacing.padding(theme, [SpacingName.SMALLER, SpacingName.MEDIUM])}
`;

export const caption: ThemedFunctor = ({ theme }) => css`
  ${getTypography(theme, TypographyName.SMALL)}
  margin-bottom: .25rem;
`;

export const title: ThemedFunctor = ({ theme }) => css`
  ${getTypography(theme, TypographyName.H2)}
  color: ${theme.palettes.brand.primary};
`;

export const description: ThemedFunctor = ({ theme }) => css`
  ${getTypography(theme, TypographyName.BODY)}
  color: ${theme.palettes.neutrals.dark};
`;

export const action: ThemedFunctor = ({ theme }) => css`
  ${getSpacing.marginTop(theme, SpacingName.SMALL)}
`;
